import React, { memo } from 'react'

import moment from 'moment'

import { Button, message } from 'antd'

import { FlexBoxY } from 'common/components/boxes'

import { CopyInviteLink } from 'contractor/components/CopyInviteLink'

import { ManagedVendorUser } from 'vendor/server/vendor_settings/manage_users'

type UserInviteProps = ManagedVendorUser

const UserInvite = memo(
  ({
    id,
    last_sign_in_at,
    invitation_sent_at,
    created_at,
    invitation_expires_at,
    invitation_link,
    can_manage_users,
    resendInvitation,
  }: UserInviteProps) => {
    const isExpired = moment(invitation_expires_at).isBefore(moment())

    if (last_sign_in_at || !invitation_sent_at) {
      return <div>{moment(created_at).format('lll')}</div>
    }

    return (
      <FlexBoxY alignItems="flex-start">
        Invited At: {moment(invitation_sent_at).format('lll')}
        {can_manage_users && (
          <Button
            data-cy={`vendor-setting-resend-invitation-${id}`}
            type="link"
            style={{ padding: '0' }}
            onClick={async () => {
              await resendInvitation(id)
              message.success('Resent invitation')
            }}
          >
            Resend invitation
          </Button>
        )}
        {can_manage_users && <CopyInviteLink isExpired={isExpired} record_id={id} invitation_link={invitation_link} />}
      </FlexBoxY>
    )
  },
)
export default UserInvite
